<div class="form-search">
      <form class="form-custom" (submit)="send()">
          <input type="text" [(ngModel)]="dataItem.termo" placeholder="{{'O que você procura?' | translate}}" name="termo" />
          <button>
              <i class="material-icons">search</i>
          </button>    
      </form>    
  </div>    